import { useTranslation } from 'react-i18next';
import { Badge } from '@/shared/ui/badge';
import { CompanyBookingStatus } from '@cargovibe/shared-types';

type BadgeVariant = React.ComponentProps<typeof Badge>['variant'];

const bookingVariantMap: Record<CompanyBookingStatus, BadgeVariant> = {
  [CompanyBookingStatus.Confirmed]: 'success',
  [CompanyBookingStatus.Cancelled]: 'destructive',
  [CompanyBookingStatus.PaymentRequired]: 'warning',
};

interface BookingStatusBadgeProps {
  status: CompanyBookingStatus;
}

export function BookingStatusBadge({ status }: BookingStatusBadgeProps): React.JSX.Element {
  const { t } = useTranslation();
  return <Badge variant={bookingVariantMap[status]}>{t(`bookings.status.${status}`)}</Badge>;
}
